import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../services/account.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  hide = true;
  updateForm: FormGroup;
  token: string;
  constructor(private formBuilder: FormBuilder,
    private accountService: AccountService,
    private route: ActivatedRoute,
    private router:Router) { }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token != null) {
      this.token = token;
      this.updateForm = this.formBuilder.group({
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required]
      })
    }
    else{
      this.router.navigate(['main']);
    }

  }

  submit() {
    let data = {
      'token': this.token,
      'password': this.updateForm.get('password').value,
      'confirm_password': this.updateForm.get('confirmPassword').value
    }
    this.accountService.resetPassword(data).then((res:any) => {
      console.log(res)
      if(res.success){
      this.router.navigate(['main']);
      alert('Password Changed Successfully')
      }

      else{
        alert(res.error)
      }

    })
      .catch((error) => {
        alert(error)
        console.log(error)
      })
  }

}
